<!--公共常用语管理-->
<template>
    <div id="sentence" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>帮助文档</el-breadcrumb-item>
                <el-breadcrumb-item>公共常用语</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="sentence-tree-container">
            <div class="search-ctn">
                <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-plus"
                    class="search-btn"
                    @click="edit(1)"
                >新增</el-button>
            </div>
            <div>
                <el-tree
                    class="klass-tree"
                    :props="treeProps"
                    :data="sentencesList"
                    :expand-on-click-node="true"
                >
                    <span class="sentence-tree-node" slot-scope="{ node, data }">
                        <span>{{data.Item.Sentence}}</span>
                        <span>
                            <el-button
                                    v-if="permission.新增"
                                type="text"
                                size="mini"
                                @click.stop.native="() => edit(1,data)"
                            >新增</el-button>
                            <el-button
                                    v-if="permission.编辑"
                                type="text"
                                size="mini"
                                @click.stop.native="() => edit(2,data)"
                            >编辑</el-button>
                            <el-button
                                    v-if="permission.删除"
                                type="text"
                                size="mini"
                                @click.stop.native="() => remove(data)"
                            >删除</el-button>
                        </span>
                    </span>
                </el-tree>
            </div>
        </div>
        <el-dialog
            :title="dialogTitle"
            :before-close="handleClose"
            :visible.sync="dialogVisible"
            width="390px"
        >
            <div style="padding-top: 20px">
                <el-input v-model="treeNodeName" placeholder="请输入常用语"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button class="btn-primary" @click="changeNodeName()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
export default {
  name: "sentence",
  data() {
    return {
        dialogTitle: "编辑",
        dialogType: 1, // 1 新增 2 修改
        treeProps: {
            children: "Children"
        },
        treeNodeName: "",
        editingnode: {},
        editingData: {},
        dialogVisible: false,
        sentencesList: [],
        permission:{}
    };
  },
  mounted() {
    this.GetSentencesList();
    this.$util.getPermission('公共常用语').then((res)=>{
        this.permission = res
    })
  },
  methods: {
    //
    handleClose() {
      this.treeNodeName = "";
      this.dialogVisible = false;
    },
    // 获取公共常用语
    GetSentencesList() {
      this.axios.get("/UsefulSentences/GetPubUsefulSentencesList").then(res => {
        this.sentencesList = res.data.data;
      });
    },
    // 修改节点名称
    edit(type, data) {
      this.dialogType = type;
      // 新增
      if (type == 1) {
        this.dialogTitle = "新增";
        if (data) {
          this.editingData = data.Item;
        } else {
          this.editingData = {};
        }
      }
      // 编辑
      else if (type == 2) {
        this.dialogTitle = "编辑";
        if (data) {
          this.editingData = data.Item;
          this.treeNodeName = data.Item.Sentence;
        }
      }
      this.dialogVisible = true;
    },
    changeNodeName() {
      let data = this.editingData;
      if (this.dialogType == 1) {
        this.axios
          .post("/UsefulSentences/EditUsefulSentences", {
            id: "",
            fid: data ? data.Id : "",
            sid: "",
            sentence: this.treeNodeName
          })
          .then(() => {
            this.dialogVisible = false;
            this.treeNodeName = "";
            this.GetSentencesList();
            this.$util.successMsg("新增成功");
          });
      } else if (this.dialogType == 2) {
        this.axios
          .post("/UsefulSentences/EditUsefulSentences", {
            id: data.Id,
            fid: data.ParentId,
            sid: "",
            sentence: this.treeNodeName
          })
          .then(() => {
            this.dialogVisible = false;
            this.treeNodeName = "";
            this.GetSentencesList();
            this.$util.successMsg("修改成功");
          });
      }
    },
    // 删除节点
    remove(data) {
      let that = this;
      if (data.Children.length > 0) {
        that.$util.warningMsg("请先删除该节点下的子项！");
        return;
      }
      this.$util.elConfirm({
        that: this,
        content: "确定删除此常用语？",
        confirm() {
          that.axios
            .post("/UsefulSentences/DeleteUsefulSentences?ids=" + data.Item.Id)
            .then(() => {
              that.GetSentencesList();
              that.$message({
                message: "删除成功",
                type: "success"
              });
            })
            .catch(error => {
              that.$message.error("删除失败！");
            });
        }
      });
    },
    // 递归遍历树修改数据
    traverseTree(id, node) {
      if (!node) {
        return;
      }
      if (node.id == id) {
        node.label = this.treeNodeName;
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.dialogVisible = false;
        return;
      }
      if (node.children && node.children.length > 0) {
        for (var i = 0; i < node.children.length; i++) {
          this.traverseTree(id, node.children[i]);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
// .klass {

// }
.sentence-tree-container {
  max-width: 1200px;
  margin: 0 auto;
}

.sentence-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
<style lang="less">
.klass-tree {
  .el-tree-node__content {
    height: 50px;
    background: @border4Color;
    border-bottom: 1px solid @border3Color;
    margin-bottom: 2px;
  }
}
</style>
